import * as React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import StepConnector, {stepConnectorClasses} from '@mui/material/StepConnector';

const QontoConnector = styled(StepConnector)(({theme}) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 20,
    left: 'calc(-50% + 25px)',
    right: 'calc(50% + 25px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#FF6B35',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#FF6B35',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(
    ({theme, ownerState}) => ({
      'color': '#666666',
      'display': 'flex',
      'height': 40,
      'width': 40,
      'alignItems': 'center',
      'justifyContent': 'center',
      'borderRadius': '50%',
      'backgroundColor': '#eaeaf0',
      'fontSize': '16px',
      'fontWeight': 'bold',
      'border': '2px solid #d0d0d0',
      ...(ownerState.active && {
        backgroundColor: '#FF6B35',
        color: '#ffffff',
        border: '2px solid #FF6B35',
      }),
      ...(ownerState.completed && {
        backgroundColor: '#FF6B35',
        color: '#ffffff',
        border: '2px solid #FF6B35',
      }),
      '& .QontoStepIcon-completedIcon': {
        color: '#ffffff',
        zIndex: 1,
        fontSize: 20,
      },
      '& .QontoStepIcon-circle': {
        width: 40,
        height: 40,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }),
);

const QontoStepIcon = (props) => {
  const {active, completed, className, icon} = props;

  return (
    <QontoStepIconRoot ownerState={{active, completed}} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <span>{icon}</span>
      )}
    </QontoStepIconRoot>
  );
};
QontoStepIcon.propTypes = {
  active: PropTypes.any,
  completed: PropTypes.any,
  className: PropTypes.any,
  icon: PropTypes.any,
};


const TopStepper = (props) => {
  const steps = props.steps;
  const activeStep = props.activeStep;
  const stepLabels = props.stepLabels || [];

  return (
    <Stack sx={{width: '100%'}} spacing={4}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
        {
          [...Array(steps)].map((_, index) => (
            <Step key={index}>
              <StepLabel
                StepIconComponent={(iconProps) => (
                  <QontoStepIcon {...iconProps} icon={index + 1} />
                )}
              >
                {stepLabels[index] || `Step ${index + 1}`}
              </StepLabel>
            </Step>
          ))
        }
      </Stepper>
    </Stack>
  );
};
TopStepper.propTypes = {
  steps: PropTypes.any,
  activeStep: PropTypes.any,
  stepLabels: PropTypes.array,
};

export default TopStepper;
